import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Signup = () => {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    mobile: '',
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate mobile number with country code
    if (!formData.mobile.startsWith('+')) {
      toast.error("Please include your country code (e.g., +91)");
      return;
    }

    // Check if passwords match
    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

  

    // ── Client-side password validation ──
    const pwd = formData.password;
    const pwdErrors = [];
    if (pwd.length < 8)         pwdErrors.push("• At least 8 characters long");
    if (!/[A-Z]/.test(pwd))    pwdErrors.push("• At least one uppercase letter (A-Z)");
    if (!/[a-z]/.test(pwd))    pwdErrors.push("• At least one lowercase letter (a-z)");
    if (!/[0-9]/.test(pwd))    pwdErrors.push("• At least one number (0-9)");
    if (!/[^\w\s]/.test(pwd))  pwdErrors.push("• At least one special character (e.g. @, #, $, !)");
    if (pwdErrors.length > 0) {
      toast.error(
        <div>
          <span style={{ fontWeight: "400" }}>Password does not meet requirements:</span>
          <ul style={{ margin: "6px 0 0 0", paddingLeft: "4px", listStyle: "none", fontSize: "13px" }}>
            {pwdErrors.map((e, i) => <li key={i}>{e}</li>)}
          </ul>
        </div>,
        { autoClose: 6000 }
      );
      return;
    }

    setLoading(true);

    try {
      const payload = {
        full_name: formData.full_name,
        email: formData.email,
        mobile: formData.mobile,
        password: formData.password
      };

      console.log('=== SENDING PAYLOAD ===');
      console.log(payload);

      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}/api/signup`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
      });

      console.log('=== RESPONSE STATUS ===');
      console.log('Status:', response.status);
      console.log('OK:', response.ok);

      // Get raw response text
      const responseText = await response.text();
      console.log('=== RAW RESPONSE TEXT ===');
      console.log(responseText);

      let data;
      try {
        data = JSON.parse(responseText);
        console.log('=== PARSED DATA ===');
        console.log(data);
        console.log('All keys in data:', Object.keys(data));
      } catch (e) {
        console.error('Failed to parse JSON:', e);
        toast.error('Server returned invalid response');
        return;
      }

      if (!response.ok) {
        console.log('=== ERROR HANDLING ===');
        console.log('data.errorMessage:', data.errorMessage);
        console.log('data.error:', data.error);
        console.log('data.message:', data.message);
        
        // Try all possible error fields
        let errorMsg = 'Registration failed';
        
        if (data.errorMessage) {
          errorMsg = data.errorMessage;
          console.log('Using errorMessage:', errorMsg);
        } else if (data.error) {
          errorMsg = data.error;
          console.log('Using error:', errorMsg);
        } else if (data.message) {
          errorMsg = data.message;
          console.log('Using message:', errorMsg);
        } else {
          console.log('No error field found, using default');
        }
        
        console.log('Final error message to show:', errorMsg);
        toast.error(errorMsg);
        return;
      }

      console.log('=== SUCCESS ===');
      toast.success("Account created successfully!");
      navigate('/login');

    } catch (err) {
      console.error("=== CATCH ERROR ===");
      console.error(err);
      toast.error("Server connection failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card shadow p-4" style={{ width: '400px', borderRadius: '12px' }}>
        <h3 className="text-center mb-4" style={{ color: '#2f7a87', fontWeight: 'bold' }}>
          Sign Up
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label small fw-bold">Full Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Name"
              required
              value={formData.full_name}
              onChange={(e) =>
                setFormData({ ...formData, full_name: e.target.value })
              }
            />
          </div>

          <div className="mb-3">
            <label className="form-label small fw-bold">Email address</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter email"
              required
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />
          </div>

          <div className="mb-3">
            <label className="form-label small fw-bold">Mobile</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter mobile number with country code (e.g., +91XXXXXXXXXX)"
              required
              value={formData.mobile}
              onChange={(e) =>
                setFormData({ ...formData, mobile: e.target.value })
              }
            />
            <small className="text-muted">Format: +[country code][number]</small>
          </div>

          <div className="mb-3">
            <label className="form-label small fw-bold">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter Password"
              required
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
            />
            <small className="text-muted">
              Must contain 8+ characters with uppercase, lowercase, number and symbol
            </small>
          </div>

          <div className="mb-3">
            <label className="form-label small fw-bold">Confirm Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Confirm Password"
              required
              value={formData.confirmPassword}
              onChange={(e) =>
                setFormData({ ...formData, confirmPassword: e.target.value })
              }
            />
          </div>

          <button
            type="submit"
            className="btn w-100 py-2"
            disabled={loading}
            style={{
              backgroundColor: '#2f7a87',
              color: 'white',
              fontWeight: '600'
            }}
          >
            {loading ? 'Signing Up...' : 'Sign Up'}
          </button>
        </form>

        <div className="mt-3 text-center">
          <Link
            to="/login"
            style={{
              color: '#2f7a87',
              textDecoration: 'none',
              fontWeight: '600'
            }}
          >
            Already have an account? Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Signup;